import React, { useState } from "react";
import { SortingState } from "@tanstack/react-table";
import { SortableTableColumn, SortableTableRow } from "../../SortableTable/Types";
import { SortableTable } from "../../SortableTable/SortableTable";
import {
  TableProps,
  TableHeaderProps,
  TableDataRowProps,
  TableDataProps
} from "./Types";
import "./Style.scss";

interface TableContainerViewProps {
  /**
   * Text for the empty state
   */
  emptyStateText: string;
  /**
   * Table definition
   */
  table: TableProps;
  /**
   On Table row selection
   * @param e event object for the particular row selection
   */
  onRowSelected?: (e: React.MouseEvent<any>) => void;
}

export const TableContainerView: React.FC<TableContainerViewProps> = (props: TableContainerViewProps) => {
  const { table, emptyStateText, onRowSelected } = props;
  const name = table.headerRow.find((i) => i.propertyName === "name");
  const sortingState = name !== undefined ? [{ "id": "name", "desc": false }] : [];
  const [sorting, setSorting] = useState<SortingState>(sortingState);

  const columnData: SortableTableColumn[] = table?.headerRow?.map((item: TableHeaderProps) => {
    return {
      key: item.propertyName,
      label: item.title,
      meta: {
        style: {
          width: item.width
        }
      },
      sortable: item.sortable ?? true
    };
  });

  const rowData: SortableTableRow[] = table?.dataRow?.map((item: TableDataRowProps): SortableTableRow => {
    const thisRow: SortableTableRow = {};
    item.row.forEach((data: TableDataProps) => {
      thisRow[data.propertyName] = data.value;
    });

    return thisRow;
  });

  return (
    table?.dataRow?.length > 0 ? (
      <SortableTable
        columnData={columnData}
        rowData={rowData}
        sortState={sorting}
        onSortChange={setSorting}
        onRowSelected={onRowSelected}
        stickyHeader={true} />
    ) : (
      <div className="table-container-empty-list">{emptyStateText}</div>
    )
  );
};
